import { CONFIGURATION_APIS } from "@/api_framework/api_config";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setClinicCopyImagesList } from "@/app_redux/reducers/slices/auth/configuration_slice";
import axios, { AxiosError } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useCurlLogger } from "../../useCurlLogger";
import AxiosCurlirize from "axios-curlirize";

AxiosCurlirize(axios, () => {});
export const useConfigurationClincCopyImagesListAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(
    async (clinic_id: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

        const response = await axios.get(`${CONFIGURATION_APIS?.CLINIC_COPY_IMAGES?.baseURL}`, {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
          params: {
            clinic_id: clinic_id,
          },
        });

        if (response.data.status === true) {
          dispatch(
            setClinicCopyImagesList({
              data: response.data.data,
            }),
          );
        } else {
          toast.error("Error while fetching images for clinic.");
        }
      } catch (error) {
        // Handle errors
        if (axios.isAxiosError(error)) {
          const axiosError = error as AxiosError;
          sendCurl(axiosError.config["curlCommand"]);
          if (axiosError.code === "ERR_BAD_REQUEST") {
            toast.error("Error at server while fetching clinic copy images details.");
          }
          if (axiosError.response?.status === 400) {
            toast.error(axiosError.message);
          }
          if (axiosError.response?.status === 500) {
            toast.error("Internal Server Error, Contact Tech Team.");
          }
        } else {
          toast.error("Server Error: " + error.message);
        }
      }
    },
    [dispatch, configuration],
  );

  return execute;
};
